export function getCountryNamesFromApi(countries) {
	return (countries || [])
		.map(item => String(item?.country || item?.title || '').trim())
		.filter(Boolean)
}

export function getCourseNamesFromApi(courses) {
	return (courses || [])
		.map(item => String(item?.specialization || item?.title || '').trim())
		.filter(Boolean)
}

export function filterValidTitles(selected, available) {
	if (!Array.isArray(selected) || !selected.length) return []
	const availableSet = new Set(available)
	return selected.filter(item => availableSet.has(item))
}

/**
 * After career change: resolve draft country for course API + country selection flag.
 */
export function reconcileCountrySelection({
	draftCountry,
	selectedCountries,
	availableCountries,
	isSelectedCountry,
}) {
	const available = getCountryNamesFromApi(availableCountries)
	const availableSet = new Set(available)
	const selected = Array.isArray(selectedCountries)
		? selectedCountries.filter(Boolean)
		: []

	const validSelected = filterValidTitles(selected, available)
	let nextIsSelectedCountry = isSelectedCountry

	if (isSelectedCountry && selected.length) {
		nextIsSelectedCountry = validSelected.length > 0
	}

	let nextDraftCountry = draftCountry || ''

	if (nextDraftCountry && availableSet.has(nextDraftCountry)) {
		return {
			draftCountry: nextDraftCountry,
			isSelectedCountry: nextIsSelectedCountry,
			draftChanged: false,
		}
	}

	if (validSelected.length > 0) {
		return {
			draftCountry: validSelected[0],
			isSelectedCountry: true,
			draftChanged: validSelected[0] !== draftCountry,
		}
	}

	return {
		draftCountry: available[0] || nextDraftCountry,
		isSelectedCountry: false,
		draftChanged: (available[0] || nextDraftCountry) !== draftCountry,
	}
}

/**
 * After country/career change: keep course selection if any selected course remains valid.
 */
export function reconcileCourseSelection({
	selectedCourses,
	availableCourses,
	isSelectedCourse,
	draftCourse,
}) {
	const available = getCourseNamesFromApi(availableCourses)
	const selected = Array.isArray(selectedCourses)
		? selectedCourses.filter(Boolean)
		: []

	if (!isSelectedCourse || !selected.length) {
		const draftValid =
			draftCourse && available.includes(draftCourse)
				? draftCourse
				: available[0] || ''
		return {
			selectedCourses: [],
			isSelectedCourse: false,
			draftCourse: draftValid,
			changed: false,
		}
	}

	const validSelected = filterValidTitles(selected, available)

	if (validSelected.length > 0) {
		const nextDraft = validSelected[validSelected.length - 1]
		return {
			selectedCourses: validSelected,
			isSelectedCourse: true,
			draftCourse: nextDraft,
			changed:
				validSelected.length !== selected.length || nextDraft !== draftCourse,
		}
	}

	return {
		selectedCourses: [],
		isSelectedCourse: false,
		draftCourse: available[0] || '',
		changed: true,
	}
}
